<template>
    <div>
        <div v-if="loading" class="ix-sending-loader mt-2 mb-2">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des signatures
        </div>

        <span class="mt-2 mb-2 d-block ix-text-secondary" v-if="signatures.length == 0 && !loading">Il n'y a pas de
            signatures associées</span>

        <div class="mt-2 mb-2">
            <div class="ix-signature-line" v-for="(signature, index) in signatures">
                <div class="ix-signature-line-left">
                    <button class="ix-btn link" @click="showSignature(signature, index)">{{ signature.identity }}</button>
                    <span v-if="signature.user_id && signature.type == 1" class="ix-text-blue ml-1">
                        <i class="fas fa-badge-check"></i>
                    </span>
                    <span class="ml-1" v-b-tooltip :title="signature.validated_at | formatDate"
                        v-bind:class="{ 'ix-text-green': signature.validated_at, 'ix-text-tertiary': !signature.validated_at }">
                        <i class="far fa-check"></i>
                    </span>
                </div>
                <div class="ix-signature-right text-right">
                    {{ signature.created_at | formatDate }}
                </div>
            </div>
        </div>

        <button class="ix-btn" @click="initSignature()" v-if="canSign">Signer</button>

        <div class="modal fade" id="showSignatureModal" tabindex="-1" aria-labelledby="showSignatureModal"
            aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="far fa-file-signature"></i> Détail de la signature</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body" v-if="selectedSignature">
                        <div class="ix-bloc-simple-line">
                            <h3 class="ix-bloc-simple-line-title">Méthode</h3>
                            {{ selectedSignature.type == 1 ? 'Electronique' : 'Manuscrite' }}
                        </div>
                        <div class="ix-bloc-simple-line">
                            <h3 class="ix-bloc-simple-line-title">Identité</h3>
                            {{ selectedSignature.identity }}
                            <span v-if="selectedSignature.user_id && selectedSignature.type == 1" class="ix-text-blue ml-1">
                                <i class="fas fa-badge-check"></i>
                            </span>
                        </div>
                        <div class="ix-bloc-simple-line">
                            <h3 class="ix-bloc-simple-line-title">Le</h3>
                            {{ selectedSignature.created_at | formatDate }}
                        </div>
                        <div class="ix-bloc-simple-line">
                            <h3 class="ix-bloc-simple-line-title">Validée le</h3>
                            <span v-if="selectedSignature.validated_at">{{ selectedSignature.validated_at | formatDate
                            }}</span>
                            <span v-if="!selectedSignature.validated_at">La signature est en attente de validation</span>
                        </div>
                        <div class="ix-bloc-simple-line"
                            v-if="selectedSignature.type == 1 && selectedSignature.validated_at">
                            <h3 class="ix-bloc-simple-line-title">Validation par</h3>
                            {{ selectedSignature.recipient }}
                        </div>
                        <div v-if="selectedSignature.type == 2" class="mt-4">
                            <img :src="selectedSignature.data_url" alt="Signature" class="img-fluid"
                                style="max-height: 100px;">
                        </div>
                    </div>

                    <div class="modal-footer" v-if="selectedSignature && selectedSignature.is_deletable">
                        <button type="button" class="ix-btn red" @click="deleteSignature()"><i class="far fa-trash"></i>
                            Supprimer</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="initSignatureModal" tabindex="-1" aria-labelledby="initSignatureModal"
            aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="far fa-file-signature"></i> Enregistrer une nouvelle signature
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="sending-type">Méthode</label>
                            <select id="sending-type" class="form-control" v-model="form.type" name="signature[type]">
                                <option value="1">Electronique</option>
                                <option value="2">Manuscrite</option>
                            </select>
                        </div>

                        <div class="form-group" v-if="reception == false || typeof reception === 'undefined'">
                            <label for=" identityAutocomplete">Salarié</label>
                            <input class="form-control" type="text" v-model="form.identity" id="identityAutocomplete"
                                :disabled="!canChangeIdentity" name="signature[identity]" required>
                        </div>

                        <div class="form-group" v-if="reception == true">
                            <label for="identity">Signataire</label>
                            <input class="form-control" type="text" v-model="form.identity" name="signature[identity]"
                                required placeholder="Nom, Prénom" id="identity">
                        </div>

                        <div class="alert alert-info"
                            v-if="form.user && !form.user.email && !form.user.email_private && form.type == 1 && reception == false">
                            La fiche de ce salarié ne contient pas d'adresse mail utilisable pour authentifier la signature
                        </div>

                        <div class="alert alert-success"
                            v-if="form.user && (form.user.email || form.user.email_private) && form.type == 1">
                            La signature est en mesure d'être authentifiée à l'aide d'une adresse mail
                        </div>

                        <div class="form-group"
                            v-show="!form.user && form.type == 1 || reception == true && form.type == 1">
                            <label for="signature-email">Adresse email</label>
                            <input class="form-control" type="email" v-model="form.email" id="signature-email"
                                name="signature[email]" :required="form.type == 1 && !form.user">
                        </div>

                        <div class="form-group" v-show="form.type == 2">
                            <label>Signez à l'aide d'un stylet ou de votre doigt dans l'encadré ci-dessous</label>
                            <div class="ix-signature-pad">
                                <VueSignaturePad height="200px" ref="signaturePad" :options="{ onBegin, onEnd }" />
                            </div>
                            <button type="button" class="ix-btn link mt-2" @click="clearSignature"><i
                                    class="far fa-eraser"></i> Effacer l'encadré</button>

                            <textarea name="signature[data_url]" v-model="form.data_url" :required="form.type == 2"
                                style="display: none;"></textarea>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm"
                            @click="sign()">
                            <span v-if="!loadingForm"><i class="far fa-signature"></i> Signer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";

export default {
    name: "SignaturesReceptions",
    props: {
        signableType: String,
        signableId: Number,
        order: String, // normal or reverse
        canSign: Boolean,
        canChangeIdentity: Boolean,
        admin: Boolean,
        usersRoute: String,
        auth: {},
        url: "",
        reception: Boolean
    },
    data() {
        return {
            loading: true,
            loadingForm: false,
            form: this.getEmptyForm(),
            signatures: [],
            selectedSignature: null,
            selectedIndex: null,
        }
    },
    methods: {
        async getData() {
            this.loading = true;
            fetch(this.url + "?signable_type=" + this.signableType + "&signable_id=" + this.signableId + "&orderBy=" + (this.order == 'normal' ? 'created_at' : '!created_at'), {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.signatures = data
                    })
                }
            }).catch(error => {
                this.loading = false
                console.log(error)
            });
        },
        async initSignature() {
            $('#initSignatureModal').modal()
        },
        getEmptyForm() {
            let auth = JSON.parse(this.auth)

            return {
                type: 1,
                identity: auth.fullname,
                email: '',
                data_url: null,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        },
        onBegin() {
            this.$refs.signaturePad.resizeCanvas()
        },
        onEnd() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
            this.form.data_url = data
        },
        clearSignature() {
            this.form.data_url = null
            this.$refs.signaturePad.clearSignature()
        },
        validateEmail() {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)
        },
        checkForm() {
            if (this.form.type == 1) {
                if (this.form.user) {
                    return this.form.identity && (this.form.user.email || this.form.user.email_private)
                } else {
                    return this.form.identity && this.form.email && this.validateEmail()
                }
            } else {
                return this.form.identity && this.form.data_url != null
            }
        },
        async sign() {
            this.loadingForm = true
            var data = {
                type: this.form.type,
                identity: this.form.user ? this.form.user.fullname : this.form.identity,
                user_id: this.form.user ? this.form.user.id : null,
                signable_type: this.signableType,
                signable_id: this.signableId,
                recipient: this.form.type == 1 ? (this.form.user ? null : this.form.email) : null,
                data_url: this.form.type == 2 ? this.form.data_url : null,
            }

            fetch(this.url, {
                ...{
                    method: 'POST',
                    body: JSON.stringify(data)
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingForm = false;
                if (response.ok) {
                    response.json().then((data) => {
                        if (data == true) {
                            this.getData()
                            $('#initSignatureModal').modal('hide');
                            this.form = this.getEmptyForm()
                            this.clearSignature()
                        } else {
                            this.$swal({
                                title: "Erreur",
                                text: "Une erreur s'est produite, la signature a été annulée",
                                icon: "error",
                                button: "Compris",
                            })
                        }

                    })
                }
            }).catch(error => {
                this.loadingForm = false;
                console.log(error);
            })
        },
        async deleteSignature() {
            this.$swal({
                title: "Êtes vous sûr ?",
                text: "La signature sera définitivement supprimée",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    $('#showSignatureModal').modal('hide');
                    this.signatures.splice(this.selectedIndex, 1)

                    fetch(this.url + "/" + this.selectedSignature.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                    }).catch(error => {
                        console.log(error);
                    })
                }
            });
        },
        showSignature(signature, index) {
            this.selectedSignature = signature
            this.selectedIndex = index
            $('#showSignatureModal').modal()
        },
        searchParamForInit() {
            if (this.searchInUrl('initSignature') != null) {
                this.initSignature();
                history.pushState("", document.title, window.location.pathname);
            }
        }
    },
    async mounted() {
        // Ouverture modal de signature depuis URL
        this.searchParamForInit()

        await this.getData()

        $("#identityAutocomplete").autocomplete({
            minLength: 2,
            source: (request, response) => {
                $.ajax({
                    url: this.usersRoute,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.fullname,
                                value: item.fullname,
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    this.form.user = null
                }
            },
            select: (e, item) => {
                this.form.identity = item.item.fullname
                this.form.user = item.item
            }
        }).focus(() => {
            $("#identityAutocomplete").autocomplete("search", '');
        });
    }
}
</script>
